import { render, staticRenderFns } from "./UpdateContractRoles.vue?vue&type=template&id=4fc07ec7&scoped=true&"
import script from "./UpdateContractRoles.vue?vue&type=script&lang=js&"
export * from "./UpdateContractRoles.vue?vue&type=script&lang=js&"
import style0 from "./UpdateContractRoles.vue?vue&type=style&index=0&id=4fc07ec7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc07ec7",
  null
  
)

export default component.exports